<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title">GONE IN A FLASH</h1>
<h2 class="book-author">Susan Rogers Cooper</h2>
<p class="publisher-logo"><img alt="Logo Missing" height="51" src="images/logo.jpg" width="72"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?338e8f8c